import React, {useRef, useState} from "react";
import Dialog from "@mui/material/Dialog";
import {Box, Checkbox, FormControlLabel} from "@mui/material";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import TextField from "@mui/material/TextField";
import DialogFormActions from "../shared/DialogFormActions";

function TTSServiceProviderCreate({provider, onClose, onSubmit}) {
    const [name, setName] = useState(provider ? provider.name : '');
    const [supportsSpeed, setsupportsSpeed] = useState(provider ? provider.supportsSpeed : false);
    const [supportsMix, setSupportsMix] = useState(provider ? provider.supportsMix : false);
    const [supportsEmotion, setSupportsEmotion] = useState(provider ? provider.supportsEmotion : false);
    const [supportsPitch, setsupportsPitch] = useState(provider ? provider.supportsSpeed : false);

    const dialogRef = useRef(null);

    const handleSubmit = e => {
        e.preventDefault();
        onSubmit({name, supportsSpeed, supportsMix, supportsEmotion, supportsPitch});
    };

    const handleClose = (event: {}, reason: "backdropClick" | "escapeKeyDown") => {
        if (reason === "backdropClick" || reason === "escapeKeyDown") {
            return;
        }
        onClose();
    };

    return (
        <React.Fragment>
            <Dialog
                open={true}
                onClose={handleClose}
                className="core-dialog"
            >
                <Box ref={dialogRef}>
                    <DialogTitle sx={{fontWeight: 'bold'}}>{provider ? 'Edit' : 'Create'} TTS Service Provider</DialogTitle>
                    <form
                        onSubmit={handleSubmit}
                        style={{display: 'contents'}}
                        className="core-form"
                    >
                        <DialogContent className="core-dialog-content">
                            <div className="core-form-row-item">
                                <TextField
                                    autoFocus
                                    required
                                    margin="dense"
                                    id="name"
                                    label="Name"
                                    name="name"
                                    variant="standard"
                                    value={name}
                                    fullWidth
                                    onChange={e => setName(e.target.value)}
                                />
                            </div>

                            <div className="core-form-row-item">
                                <FormControlLabel
                                    label="Supports Speed"
                                    control={
                                        <Checkbox
                                            id="supportsSpeed"
                                            name="supportsSpeed"
                                            checked={supportsSpeed}
                                            onChange={e => setsupportsSpeed(e.target.checked)}
                                        />
                                    }
                                />
                            </div>

                            <div className="core-form-row-item">
                                <FormControlLabel
                                    label="Supports Mix"
                                    control={
                                        <Checkbox
                                            id="supportsMix"
                                            name="supportsMix"
                                            checked={supportsMix}
                                            onChange={e => setSupportsMix(e.target.checked)}
                                        />
                                    }
                                />
                            </div>

                            <div className="core-form-row-item">
                                <FormControlLabel
                                    label="Supports Emotion"
                                    control={
                                        <Checkbox
                                            id="supportsEmotion"
                                            name="supportsEmotion"
                                            checked={supportsEmotion}
                                            onChange={e => setSupportsEmotion(e.target.checked)}
                                        />
                                    }
                                />
                            </div>

                            <div className="core-form-row-item">
                                <FormControlLabel
                                    label="Supports Pitch"
                                    control={
                                        <Checkbox
                                            id="supportsPitch"
                                            name="supportsPitch"
                                            checked={supportsPitch}
                                            onChange={e => setsupportsPitch(e.target.checked)}
                                        />
                                    }
                                />
                            </div>
                        </DialogContent>
                        <DialogFormActions dialogRef={dialogRef} onClose={onClose}></DialogFormActions>
                    </form>
                </Box>
            </Dialog>
        </React.Fragment>
    );
}

export default TTSServiceProviderCreate;
